import { useState } from 'react';
import { getImageSrc } from '../../utils';

const ImageCheckFallback = ({ folderName, imgName, src, alt, classImg }) => {
    const transparentPixel = './images/transparent.png';
    const [hasError, setHasError] = useState(false);
    const handleError = () => {
        setHasError(true);
    };

    return (
        <>
            {imgName && !hasError ? (
                <img
                    className={classImg ? classImg : ''}
                    src={src || getImageSrc(folderName, imgName)}
                    alt={alt ? alt : ''}
                    onError={handleError}
                />
            ) : imgName === './images/default_logo.jpg' ? (
                <img className={classImg ? classImg : ''} src={imgName} alt="Default logo" />
            ) : (
                <img className={classImg ? classImg : ''} src={transparentPixel} alt="Black logo" />
            )}
        </>
    );
};
export default ImageCheckFallback;
